import { useFormContext } from 'react-hook-form'

import { FormSectionType } from '@pages/WindowsCreateOrEdit/types'

export const useSection = (sectionIndex: number) => {
  const { watch } = useFormContext<FormSectionType>()
  const watchSectionTitle = watch(`sections.${sectionIndex}.title`)
  const watchSectionId = watch(`sections.${sectionIndex}.id`)
  const {
    formState: { errors },
  } = useFormContext()

  return {
    state: { errors },
    handlers: {},
    data: {
      watchSectionId,
      watchSectionTitle,
    },
  }
}
